<template>
  <div>
    <vx-card title="Grade Summary" class="mb-4">
      <!-- {{homeworkData}} -->
      <!-- {{homework_total_points}}
            {{exam_total_points}}
            {{homework_exam_total_points}} -->
      <vs-button
        style="font-size: 13.8px; padding: 7px; float: right; margin-top: -50px"
        @click.prevent="maximizeCard = !maximizeCard"
        >{{ maximizeCard ? `Minimize` : `Maximize` }}</vs-button
      >
      <div class="vx-row" v-if="maximizeCard">
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            hideChart
            class="mb-1"
            icon="insights"
            icon-right
            :module_name="'grade_homework_total_points'"
            :homework_total_points="homework_total_points"
            :statistic="homework_statistic"
            statisticTitle="Homework Subtotal"
          />
        </div>
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            hideChart
            class="mb-1"
            icon="insights"
            icon-right
            :module_name="'grade_exam_total_points'"
            :exam_total_points="exam_total_points"
            :statistic="exam_statistic"
            statisticTitle="Exam Subtotal"
          />
        </div>
        <!-- <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
            <statistics-card-line
                hideChart
                class="mb-1"
                icon="CpuIcon"
                icon-right
                statistic="8"
                statisticTitle="Qualified"
            />
            </div> -->
        <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
          <statistics-card-line
            hideChart
            class="mb-1"
            icon="insights"
            icon-right
            :module_name="'grade_homework_exam_total_points'"
            :homework_exam_total_points="homework_exam_total_points"
            :statistic="total_statistic"
            statisticTitle="Grand Total"
          />
        </div>
      </div>
    </vx-card>

    <vs-card>
      <h4 class="text-center">Related Information</h4>
      <vs-divider />
      <vs-row>
        <vs-col class="text-center header_info" vs-w="6">
          <h5>Student Name</h5>
          <span> {{ student_name }}</span>
        </vs-col>

        <vs-col class="text-center header_info" vs-w="6">
          <h5>Course Name</h5>
          <span> {{ course_name }}</span>
        </vs-col>
      </vs-row>

      <br>

      <vs-row>
        <vs-col class="text-center header_info" vs-w="6">
          <h5>Teacher Name</h5>
          <span> {{ teacher_name }}</span>
        </vs-col>

        <vs-col class="text-center header_info" vs-w="6">
          <h5>Course Type</h5>
          <span> {{ course_type }}</span>
        </vs-col>
      </vs-row>
    </vs-card>

    <vs-card class="marks_card">
      <course-content
        v-if="showCourseContent"
        :courseContent="courseContent"
        :client_user_id="this.$route.params.client_user_id"
        :user_course_answer_master_id="this.$route.params.answer_list_id"
      />
      <div v-else>
        <h5>Loading...</h5>
      </div>

      <!-- <vs-divider/>
        <vs-button class="block mx-auto" @click="saveGrade">Save Grade</vs-button> -->
    </vs-card>
    <div style="height: 50px"></div>
    <!-- <pre>{{courseContent}}</pre> -->
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import CourseContent from './Components/CourseContent.vue'
import { studentAnswersDetails } from '@/api/grade'
import { EventBus } from './mixin/EventBus'

export default {
  name: 'marklist',
  components: {
    StatisticsCardLine,
    CourseContent
  },
  mixins: [EventBus],
  data () {
    return {
      student_name: this.$route.params.header_info.student_name,
      course_name: this.$route.params.header_info.course_name,
      teacher_name: this.$route.params.header_info.teacher_name,
      course_type: this.$route.params.header_info.course_type,
      homework_total_points: 0,
      exam_total_points: 0,
      homework_exam_total_points: 0,
      homework_statistic: 0,
      exam_statistic: 0,
      total_statistic: 0,
      homeworkData: [],
      examData: [],
      reportData: [],
      showCourseContent: false,
      courseContent: null,
      radios1: '2',
      textAnswer:
        'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries',
      maximizeCard: true
    }
  },
  mounted () {},
  created () {
    EventBus.$off('updateGradeSummary')
    EventBus.$on('updateGradeSummary', (data) => {
      //
      // if (data.assignment_type_id === 2) {
      //   this.homework_statistic = +data.value
      // } else if (data.assignment_type_id === 4) {
      //   this.exam_statistic = +data.value
      // }
      // this.total_statistic = this.homework_statistic +  this.exam_statistic

      let homework_subtotal = this.homeworkData.map((x) => {
        return x.assignment.questions
          .map((y) => {
            if (y.student_answers_new.student_answer_id !== null) {
              if (y.student_answers_new.mark !== undefined) {
                return Number(y.student_answers_new.mark)
              }
            }
          })
          .filter(Boolean)
      })

      let exam_subtotal = this.examData.map((x) => {
        return x.assignment.questions
          .map((y) => {
            if (y.student_answers_new.student_answer_id !== null) {
              if (y.student_answers_new.mark !== undefined) {
                return Number(y.student_answers_new.mark)
              }
            }
          })
          .filter(Boolean)
      })

      setTimeout(() => {
        homework_subtotal = [].concat.apply([], homework_subtotal)
        exam_subtotal = [].concat.apply([], exam_subtotal)

        this.homework_statistic = homework_subtotal.reduce((a, b) => a + b, 0)
        this.exam_statistic = exam_subtotal.reduce((a, b) => a + b, 0)
        this.total_statistic = this.homework_statistic + this.exam_statistic
      }, 100)
    })

    //Student answer details API call
    if (!this.$route.params.answer_list_id) {
      this.$router.push('grade')
    } else {
      this.studentAnswersDetails()
    }
  },
  methods: {
    saveGrade () {
      EventBus.$emit('saveGrade')
    },
    async studentAnswersDetails () {
      try {
        const customer_id = this.$store.getters.customerId
        const answer_list_id = this.$route.params.answer_list_id
        // this.courseContent
        const { data } = await studentAnswersDetails(
          customer_id,
          answer_list_id
        )
        this.courseContent = data.data.answerslist[0]
        this.showCourseContent = true

        this.homeworkData = this.courseContent.courseAssignments.filter(
          (ele) => {
            return ele.assignment.assignment_type_id === 2
          }
        )

        this.examData = this.courseContent.courseAssignments.filter((ele) => {
          return ele.assignment.assignment_type_id === 4
        })

        this.reportData = this.courseContent.courseAssignments.filter((ele) => {
          return ele.assignment.assignment_type_id === 3
        })

        let homework_subtotal = this.homeworkData.map((x) => {
          return x.assignment.questions
            .map((y) => {
              this.homework_total_points += y.point
              if (y.student_answers_new.student_answer_id !== null) {
                if (y.student_answers_new.mark !== undefined) {
                  return Number(y.student_answers_new.mark)
                }
              }
            })
            .filter(Boolean)
        })

        let exam_subtotal = this.examData.map((x) => {
          return x.assignment.questions
            .map((y) => {
              this.exam_total_points += y.point
              if (y.student_answers_new.student_answer_id !== null) {
                if (y.student_answers_new.mark !== undefined) {
                  return Number(y.student_answers_new.mark)
                }
              }
            })
            .filter(Boolean)
        })

        setTimeout(() => {
          homework_subtotal = [].concat.apply([], homework_subtotal)
          exam_subtotal = [].concat.apply([], exam_subtotal)

          this.homework_statistic = homework_subtotal.reduce(
            (a, b) => a + b,
            0
          )
          this.exam_statistic = exam_subtotal.reduce((a, b) => a + b, 0)
          this.total_statistic = this.homework_statistic + this.exam_statistic
          this.homework_exam_total_points =
            this.homework_total_points + this.exam_total_points
        }, 100)
      } catch (e) {
        this.$vs.notify({
          title: 'Error',
          text: e.errors,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      }
    }
  }
}
</script>

<style>
.marks_collapse .con-content--item {
  position: relative;
}
.marks_collapse .vs-collapse-item {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin: 10px 0;
}
.marks_collapse .vs-collapse-item--header {
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.marks_collapse .vs-collapse-item.open-item .vs-collapse-item--content {
  max-height: 100% !important;
}
.marks_collapse .answered_holder {
  width: 75%;
}
.marks_collapse .answered_holder textarea {
  min-height: 100px;
}
.marks_collapse .points_holder {
  position: absolute;
  top: 10px;
  right: 40px;
  display: flex;
  align-items: center;
}
.marks_collapse .points_holder label {
  margin-right: 10px;
  color: #000;
  font-weight: bold;
}
.marks_collapse .points_holder .vs-con-input-label {
  width: 65px;
}
.marks_card {
  position: relative;
}
.marks_card .content_holder {
  max-height: 450px;
  overflow-y: auto;
}
.marks_card .vs-tabs--ul {
  padding-bottom: 6px;
  width: calc(100% - 205px);
}
.grandtotal_holder {
  position: absolute;
  top: 4px;
  right: 30px;
  font-size: 14px;
}
.grandtotal_holder .inner_holder,
.subtotal_holder .inner_holder {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  width: 185px;
  padding: 10px;
  border-radius: 6px;
  color: #000;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  border: 1px solid #edecec;
  margin-left: auto;
}
.grandtotal_holder .inner_holder .material-icons,
.subtotal_holder .inner_holder .material-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  width: 24px;
  height: 24px;
  background: #cffbfe;
  color: #29b8c6;
  border-radius: 50%;
  padding: 5px;
  margin-right: 5px;
}
.subtotal_holder {
  text-align: right;
  font-size: 13px;
  padding: 20px 10px 0;
}
.subtotal_holder .inner_holder .material-icons {
  background: #d7f7ae;
  color: #70bd10;
}

@media (max-width: 768px) {
  .marks_collapse .points_holder {
    position: static;
    margin: 10px 0;
  }
}
</style>
<style scoped>
.header_info {
  background-color: #f0f8ffc2;
    padding: 10px;
}
</style>